import './lncanada6/style';
import FormStructure from './lncanada6/form_structure';

export default FormStructure;